import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import logoSygnet from '../assets/V1_sygnetb.png';

const EntrigyIntro = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 1800);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="w-full h-full flex items-center justify-center overflow-hidden">
      <div className="flex flex-col items-center justify-center space-y-10 scale-90 md:scale-100">
        <div className="relative flex items-center justify-center">
          <motion.div
            className="relative w-32 h-32 md:w-44 md:h-44 flex items-center justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <img
              src={logoSygnet}
              alt="Ventro Logo"
              className="w-full h-full object-contain relative z-10"
            />
          </motion.div>
        </div>

        <div className="flex flex-col items-center text-center">
          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-white font-outfit text-4xl md:text-6xl font-extralight uppercase tracking-[0.4em]"
          >
            Entrigy
          </motion.h1>

          <motion.div
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: "100%", opacity: 1 }}
            transition={{ duration: 1.2, delay: 0.5, ease: "easeInOut" }}
            className="h-[1px] bg-gradient-to-r from-transparent via-white/40 to-transparent mt-4 max-w-[320px]"
            style={{ width: '100%' }}
          />

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.0 }}
            className="text-white/55 text-[9px] mt-5 uppercase tracking-[0.4em] font-light max-w-[250px]"
          >
            Powering the Sustainable Future
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default EntrigyIntro;
